import styled from "styled-components";

export const Container = styled.div`
    align-items: center;
    display: flex;
    gap: 14px;
    height: 35px;
    justify-content: center;
    /* position: fixed; */

    @media (orientation: landscape) and (max-width: 1200px){
        gap: 10px;
    }
`;

export const SwitchContainer = styled.label`
    display: inline-block;
    height: 18px;
    position: relative;
    width: 50px;
    @media (min-width: 1281px) {
        height: 22px;
        width: 60px;
    }
`;

export const Slider = styled.span`
    background: ${props => (props.checked ? props.$colorOn : props.$colorOff)};
    border-radius: 25px;
    bottom: 0;
    box-shadow: none;
    color: white;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    transition: 0.4s;
    user-select: none;
    -webkit-transition: 0.4s;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
`;

export const Button = styled.span`
    align-items: center;
    background: ${props => (props.checked ? props.$colorOn : props.$colorOff)};
    border-radius: 50%;
    box-shadow: none;
    color: #F6F6F6;
    cursor: pointer;
    display: flex;
    font-size: 15px;
    font-style: normal;
    font-weight: 700;
    height: 28px;
    justify-content: center;
    line-height: 8.743px;
    position: absolute;
    text-align: center;
    transform: translateX(${props => (props.checked ? '28px' : '-1px')}) translateY(-5px);
    transition: 0.4s;
    user-select: none;
    width: 28px;
    -webkit-transition: 0.4s;
    -moz-user-select: none;
    -webkit-user-select: none;
    -webkit-tap-highlight-color: transparent;
    @media (min-width: 1281px) {
        height: 34px;
        width: 34px;
    }
`;

export const Input = styled.input`
    display: none;
`;

export const TextString = styled.span`
    color: ${props => (props.color)};
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    @media (min-width: 720px) {
        font-size: 12px;
    }
    @media (min-width: 1281px) {
        font-size: 16px;
    }
`;